
const fullStackApps = [
    {
        key : "1",
        title : "Car Rental Web App",
        img1 : require('../../assets/Projects/full-stack/car-rental/rental-img-1.gif'),
        desc : "This is a customized, responsive and easy to use car rental website that allows users to book available cars in real time. It comes with an Admin dashboard that facilitates the management and automation of multiple car rental functionalities. Implementing the right solution that only finds the unbooked cars in a given booking dates was too challenging, but it was possible with the use of pseudo code and flowchart and problem solving skills.",
        link : "https://oumechtaqcar.ma/",
        frameworks: "Node.js, Express, HTML, CSS, EJS, Bootstrap, jQuery, MongoDB"
    },
    {
        key : "2",
        title : "Clinical Search Web App",
        img1 : require('../../assets/Projects/full-stack/clinic/clinic-img-1.gif'),
        desc : "This is a user-friendly web application that helps users to find clinics by using the name of a city as search query or by navigatung an interactive Map component and clicking on a specific region. Using React framework in this project was paramount for optimizing UX by showing instant clinical search results on the same page, and fetching the Api data coming from MongoDB cluster. In terms of performance, SEO and page rendering Next Js was a good fit. I also created a Rest API and an Admin dashboard separately using Node.js and Express.js.",
        link : "https://maroc-cliniques.com/",
        frameworks: "Next.js, React, Node.js, Express, Bootstrap, Material UI, MongoDB"
    }
]

const landingPages = [
    {
        key : "1",
        title : "Training Academy - Landing Page",
        img1 : require('../../assets/Projects/landing-page/academy/img1.webp'),
        img2 : require('../../assets/Projects/landing-page/academy/img2.webp'),
        img3 : require('../../assets/Projects/landing-page/academy/img3.webp'),
        desc : "This landing page is designed for driving leads from Facebook campaigns. The design is fully responsive with prominent CTA and a lead form connected to google sheets for instant results.",
        link : "https://oumechtaqcar.ma/"
    },
    {
        key : "2",
        title : "Cleaning services - Landing Page",
        img1 : require('../../assets/Projects/landing-page/residential-cleaning/img1.webp'),
        img2 : require('../../assets/Projects/landing-page/residential-cleaning/img2.webp'),
        img3 : require('../../assets/Projects/landing-page/residential-cleaning/img3.webp'),
        desc : "Converting landing page",
        link : "https://maroc-cliniques.com/"
    },
    {
        key : "3",
        title : "Endocrine Clinic - Landing Page",
        img1 : require('../../assets/Projects/landing-page/endocrine-clinic/img1.webp'),
        img2 : require('../../assets/Projects/landing-page/endocrine-clinic/img2.webp'),
        img3 : require('../../assets/Projects/landing-page/endocrine-clinic/img3.webp'),
        desc : "This landing page is designed for generating leads from Google Ads campaigns. The design is interactive and responsive with prominent CTA and a lead form connected to google sheets for instant results.",
        link : "https://maroc-cliniques.com/"
    }
]



export {fullStackApps, landingPages};